import { render, staticRenderFns } from "./ReailzeCard.vue?vue&type=template&id=08f660ef&scoped=true"
import script from "./ReailzeCard.vue?vue&type=script&lang=js"
export * from "./ReailzeCard.vue?vue&type=script&lang=js"
import style0 from "./ReailzeCard.vue?vue&type=style&index=0&id=08f660ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f660ef",
  null
  
)

export default component.exports